<template>
  <v-autocomplete
    v-model="model"
    v-model:search="searchTerm"
    class="combobox-role"
    :items="orderLimitUsersFiltered"
    color="primary"
    chips
    closable-chips
    variant="filled"
    hide-details
    return-object
    multiple
    no-filter
    :no-data-text="$t('orderLimits.noEmployeeFound')"
    :aria-label="$t('orderLimits.orderApprover')"
  >
    <template #chip="{ props: chipProps, item }">
      <v-chip v-bind="chipProps" :text="getFullNameAndCompany(item)">
        <template #prepend>
          <avatar-image ref="avatar" :size="20" :user="item" left />
        </template>
      </v-chip>
    </template>

    <template #item="{ props: itemProps, item }">
      <v-list-item v-bind="itemProps" :title="getFullNameAndCompany(item)">
        <template #prepend>
          <avatar-image ref="avatar" :size="30" :user="item" left />
        </template>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script setup lang="ts">
import AvatarImage from '@/components/AvatarImage.vue'
import { getFullNameAndCompany } from '@/helpers'
import { nameAndEmailFilter, sortByName } from '@/modules/user/helpers'
import { ShortUser } from '@/types/index'
import { computed, PropType, ref } from 'vue'

const model = defineModel<ShortUser[]>()
const searchTerm = ref('')

const props = defineProps({
  approvers: {
    type: Array as PropType<ShortUser[]>,
    required: true
  }
})

const orderLimitUsersFiltered = computed(() => {
  const keyword = searchTerm.value
  if (!keyword) {
    return [...props.approvers].sort(sortByName)
  }
  return props.approvers.filter(nameAndEmailFilter(keyword)).sort(sortByName)
})
</script>
